<template>
  <div class="table-content">
    <div class="header">
      <!--日期选择-->
      <div class="startDate">
        <el-date-picker v-model="date1" size="small" type="date" @change="getSTime1" placeholder="开始日期"
          :picker-options="getSTime1Fun">
        </el-date-picker>
      </div>
      <div class="endDate">
        <el-date-picker v-model="date2" size="small" type="date" @change="getSTime2" placeholder="结束日期"
          :picker-options="getSTime2Fun">
        </el-date-picker>
      </div>
    </div>
    <div class="fun">
      <el-row>
          <el-button class="search" size="mini" @click="search()">搜索</el-button>
          <el-button class="deltale" size="mini" @click="deltale()">清除</el-button>
          <el-button class="doexcel" size="mini" @click="doexcel()">导出</el-button>
        </el-row>
    </div>
    <el-table class="loadingPrivate" max-height="500" :data="tableData"  style="width: 100%,font-size:0.5rem,margin-bottom:1rem">
      <el-table-column prop="type" label="产品" width="100"></el-table-column>
      <el-table-column prop="applyNum" label="申请人数" width="115"></el-table-column>
      <el-table-column prop="loanSuccessNum" label="授信通过人数" width="115"></el-table-column>
      <el-table-column prop="successRate" label="通过率" width="95"></el-table-column>
      <el-table-column prop="loanAmount" label="授信金额(万元)" width="120"></el-table-column>
      <el-table-column prop="disburseNum" label="支用人数" width="120"></el-table-column>
      <el-table-column prop="disburseAmopunt" label="支用额度(万元)" width="120"></el-table-column>
      <el-table-column prop="disburseRate" label="支用率" width="95"></el-table-column>
      <el-table-column prop="meanAmount" label="人均授信额度(万元)" width="150"></el-table-column>
      <el-table-column prop="revertAmount" label="还款金额(万元)" width="120"></el-table-column>
      <el-table-column prop="surplseAmount" label="贷款余额(万元)" width="120"></el-table-column>
    </el-table>
    <div class="pagination" v-if="isPage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage1" :page-size="15" layout=" prev, pager, next" :total="totalCount">
      </el-pagination>
      <div class="pagNum">共{{pagNum}}页 （共{{totalCount}}条）</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "loans1", //贷款分析表
    data() {
      return {
        tableData: [],
        paginations: {
          pageIndex: 1, // 当前位于哪页
          pageSize: 15, // 1页显示多少条
          pageSizes: [5, 10, 15, 20], //每页显示多少条
          layout: "total, sizes, prev, pager, next, jumper" // 翻页属性
        },
        currentPage1: 1,
        date1: '', //开始日期
        date2: '', //结束日期
        isPage: true,
        token: "",
        pagNum: "", //总页数
        pageNumber: 1, //页码数
        pageSize: 15, //每页条数
        totalCount: "", //总条数
        startTime: "", //开始时间
        endTime: "", //结束时间
        selectData: [], //导出excel文件
        excelData: [],
        //请求参数
        req: {
          startTime1: "", //开始时间
          endTime1: "", //结束时间
        },
        //设置日历可选择日期
        getSTime1Fun: {
          disabledDate: (time) => {
            if (this.date2) return time.getTime() > this.date2
            else return
          }
        },
        getSTime2Fun: {
          disabledDate: (time) => {
            if (this.date1) return time.getTime() < this.date1
            else return
          }
        }
      }
    },
    props: {
      pageTotal: Number
    },
    created() {
      this.token = sessionStorage.getItem('token');
      console.log("this.aasd", this.token)
      this.firstSearch()
      // this.pagNumS()
    },
    mounted() {},
    methods: {
      //条数转页数
      pagNumS() {
        let pages = Math.ceil(this.totalCount / 15)
        this.pagNum = pages;
        console.log("aaaa", this.pagNum)
      },
      // 上下分页 pageIndex
      handleCurrentChange(page) {
        let params = {
          startTime: this.req.startTime1, //开始时间
          endTime: this.req.endTime1, //结束时间
          token: this.token,
          pageNumber: this.currentPage1,
          pageSize: this.pageSize
        };
        console.log("bbbbbbbbb", params)
        let _this = this;
        // let url = 'http://uath5.unionft.cn:8083/ft-oms/backUserRecommend/backUserRecommendRelationCount.action'; //测试
        // let url = 'http://hzjkoms.unionft.cn/ft-oms/backUserRecommend/backUserRecommendRelationCount.action';//生产
        let url =  '/ft-oms/loanController/loanCollect.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.data.list
            this.totalCount = parseInt(res.data.data.totalCount)
            this.pagNumS();
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }else{
              this.tableData = [];
              this.isPage = false
            }
          }  else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
      },
      // 每页多少条切换 pageSize
      handleSizeChange(page_size) {

      },
      //获取开始日期
      getSTime1(val1) {
        this.date1 = val1
        console.log(this.date1)
        var d = new Date(this.date1);
        var youWant = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate();
        console.log(youWant)
        if(youWant=="1970/1/1"){
          youWant=""
        }
        this.startTime = youWant
        console.log("this.startTime",this.startTime)
        // this.endTime = youWant2
      },
      //获取结束日期
      getSTime2(val2) {
        this.date2 = val2
        var d2 = new Date(this.date2);
        var youWant2 = d2.getFullYear() + '/' + (d2.getMonth() + 1) + '/' + d2.getDate();
        console.log(youWant2)
        if(youWant2=="1970/1/1"){
          youWant2=""
        }
        // this.startTime = youWant
        this.endTime = youWant2
        console.log("this.endTime",this.endTime)

      },
      //首次进入加载数据
      firstSearch() {
        let params = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          startTime: "", //开始时间
          endTime: "", //结束时间
          token: this.token
        };
        let _this = this;
        // let url = 'http://uath5.unionft.cn:8083/ft-oms/backUserRecommend/backUserRecommendRelationCount.action'; //测试
        // let url = 'http://hzjkoms.unionft.cn/ft-oms/backUserRecommend/backUserRecommendRelationCount.action';//生产
        let url = '/ft-oms/loanController/loanCollect.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.data.list
            this.totalCount = parseInt(res.data.data.totalCount)
            this.pagNumS();
            this.isPage = true
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }else{
              this.tableData = [];
              this.isPage = false
            }
          }  else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
      },
      //搜索
      search() {
        if((this.startTime!=''&&this.endTime!='')||(this.startTime==''&&this.endTime=='')){
        let params = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          startTime: this.startTime, //开始时间
          endTime: this.endTime, //结束时间
          token: this.token
        };

        this.req.startTime1 = params.startTime
        this.req.endTime1 = params.endTime

        let _this = this;
        // let url = 'http://uath5.unionft.cn:8083/ft-oms/backUserRecommend/backUserRecommendRelationCount.action'; //测试
        // let url = 'http://hzjkoms.unionft.cn/ft-oms/backUserRecommend/backUserRecommendRelationCount.action';//生产
        let url =  '/ft-oms/loanController/loanCollect.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.data.list
            this.totalCount = parseInt(res.data.data.totalCount)
            this.currentPage1 = 1
            this.pagNumS();
            this.isPage = true
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }else{
              this.tableData = [];
              this.isPage = false
            }
          }  else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
        }else{
          this.$alert('请选择开始日期或结束日期', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
                // this.$message({
                // type: 'info',
                // message: `action: ${ action }`
                // });
            }
          });
        }
      },
      //清除
      deltale() {
        this.date1 = "";
        this.date2 = "";
        this.startTime = "";
        this.endTime = "";
      },
      //导出
      doexcel() {
        let params = {
          startTime: this.req.startTime1, //开始时间
          endTime: this.req.endTime1, //结束时间
          token: this.token
        };
        let _this = this;
        // let url = 'http://uath5.unionft.cn:8083/ft-oms/backUserRecommend/countIsExport.action'; //测试
        // let url = 'http://hzjkoms.unionft.cn/ft-oms/backUserRecommend/countIsExport.action';//生产
        let url =  '/ft-oms/loanController/loanCollectXls.action'
        this.$http.post(url, params, {
          responseType: 'blob'
        }).then(res => {
          if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }
          }else{
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            }); // res就是接口返回的文件流了
            let objectUrl = URL.createObjectURL(blob);
            window.location.href = objectUrl;
          } 
        },).catch((error)=>{
          console.error(error);
        });
      },
    }
  }

</script>

<style scoped>
  body {
    margin: 0;
  }

  .pagination {
    /* margin-bottom: 1.2rem; */
    margin-top: 1.2rem;
    display: flex;
    justify-content: center;
    height: 1.8rem;
    font-size: 0.9rem;
    line-height: 1.8rem;

  }

  .header {
    height: 3rem;
    display: flex;
  }

  .filiale,
  .input {
    margin-right: 0.5rem;
  }

  .startDate,
  .endDate {
    margin-right: 0.5rem;
  }

  .search {
    border: 1px solid #FF9D47;
    border-radius: 0.2rem;
    /* height: 1.7rem;
    line-height: 1.7rem;
    width: 2.8rem; */
    text-align: center;
    font-size: 0.6rem;
    color: #FF9D47;
    /* margin-right: 0.6rem; */
  }

  .deltale {
    border: 1px solid #7A7A7A;
    border-radius: 0.2rem;
    /* height: 1.7rem;
    line-height: 1.7rem;
    width: 2.8rem; */
    text-align: center;
    font-size: 0.6rem;
    color: #7A7A7A;
    /* margin-right: 0.6rem; */
  }

  .doexcel {
    border: 1px solid #FF9D47;
    border-radius: 0.2rem;
    /* height: 1.7rem;
    line-height: 1.7rem;
    width: 2.8rem; */
    text-align: center;
    font-size: 0.6rem;
    color: #ffffff;
    background: #FF9D47;
  }

  .pagNum {
    margin-left: 1.2rem;
    margin-top: 0.2rem;
  }

  .checkboxImg {
    width: 4.8rem;
    height: 1.2rem;
    border: 1px solid #999999;
    background: url("../../../static/img/sousuo-2.png") no-repeat center right;
  }

  .checkboxDiv {
    width: 4.8rem;
    display: none;
    border: 1px solid #999999;
    border-top: none;
  }

  .fun {
    display: flex;
    margin-top: 1rem;
    margin-bottom: 1rem;
    float: right;
  }

  .input {
    display: flex;
    border: 1px solid #dedede;
    width: 9rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.25rem;
    color: #bfcbd9;
  }

  .input input {
    flex: 9;
    border: 0;
    font-size: 0.8rem;
    width: 5rem;
    outline: none;
  }

  .input img {
    width: 50%;
    height: 50%;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    flex: 1;
    margin-top: 0.4rem;
  }

  
  /*修改input框默认文本样式*/
  input::-webkit-input-placeholder {
    /* placeholder颜色 */
    color: #C1C1C1;
    /* placeholder字体大小 */
    /* font-size: 12px; */
  }
  .el-input__inner {
    height: 1.8rem;
    font-size: 0.72rem;
  }
  /*修改日期框样式*/
  .startDate>>>.el-date-editor {
    width: 8rem;
  }

  .startDate>>>.el-input__inner:focus{
    border-color: #FF9D47;
  }
  .endDate>>>.el-date-editor {
    width: 8rem;
  }
  .endDate>>>.el-input__inner:focus{
    border-color: #FF9D47;
  }
  
  /*修改下拉框样式*/
  .filiale>>>.el-input__inner{
    width: 8rem;
  }
  /* .el-select-dropdown__wrap {
    background: #b5879a !important;
  } */
  .filiale>>>.el-select .el-input.is-focus .el-input__inner{
    border-color: #FF9D47;
  }
  .filiale>>>.el-select .el-input__inner:focus{
    border-color: #FF9D47;

  }
  .el-select-dropdown__item.selected{
    color: #FF9D47;
  }
  .el-select-dropdown__item.hover{
    background-color: #ffffff;
  }
  .filiale>>>.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color: #FAF0E7;
    color: #FF9D47;
  }
  
  /*修改分页样式*/
  .pagination>>>.el-pager li.active{
    color: #FF9D47;
  }
  .pagination>>>.el-pager li:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-left:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-right:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-left.active{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-right.active{
    color: #FF9D47;
  }
  .el-icon-arrow-left:hover{
    color: #FF9D47;
  }
  .el-icon-arrow-right:hover{
    color: #FF9D47;
  }
  .el-icon-arrow-left.active{
    color: #FF9D47;
  }
  .el-icon-arrow-right.active{
    color: #FF9D47;
  }
  .pagination>>>.el-pagination .btn-next:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-pagination .btn-prev:hover{
    color: #FF9D47;
  }
  
 /*按钮样式*/
  .doexcel>>> .el-button:hover{
    background-color: #FF9D47 !important;
    color: #ffffff;
    border-color: #FF9D47;
  }
  .search>>>.el-button:hover{
    background-color: #ffffff !important;
    color: #FF9D47;
    border-color: #FF9D47;
  }
  .deltale>>> .el-button--default .el-button--mini:hover{
    background-color: #ffffff !important;
    color: #000;
    border-color: #000;
  }
  .filiale >>>.el-select-dropdown__wrap{
    max-height: 295px;
  }
 
</style>



// WEBPACK FOOTER //
// loans1.vue?081e832f